module.exports = __webpack_public_path__ + "static/media/admin.05d8d724.svg";